import { ConfigurationProtocolResponse } from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.dto'

export enum ConfigurationLocalAssaysProtocolsTabIndex {
    BASIC = 0,
    ONTOLOGIES = 1,
    ASSAYS = 2
}

export interface ConfigurationLocalAssaysProtocolsModalState {
    protocol: Partial<ConfigurationProtocolResponse>,
    activeTabIndex: number
}
export const initialConfigurationLocalAssaysProtocolsModalState =
    (): ConfigurationLocalAssaysProtocolsModalState => ({
        protocol: {
            active: true
        },
        activeTabIndex: ConfigurationLocalAssaysProtocolsTabIndex.BASIC
    })
